<template>
  <v-container>
    <v-banner :value="this.receipt.isSent" elevation="4" class="mb-4">Эти показания уже отправлены в УК</v-banner>
    <v-card class="mb-4" color="red" v-if="errorMessage">
      <v-card-title>ОШИБКА</v-card-title>
      <v-card-text>{{ errorMessage }}</v-card-text>
    </v-card>
    <v-form>
      <div v-for="item in this.receipt.values" :key="item.counter.id">
        <v-text-field type="number"
                      :label="counterLabel(item.counter, 1)"
                      :error-messages="err[item.counter.id + '-1']"
                      v-model.number="item.value_1"
                      required/>
        <v-text-field v-if="item.counter.type === 'ELECTRO_2' || item.counter.type === 'ELECTRO_3'"
                      type="number"
                      :label="counterLabel(item.counter, 2)"
                      :error-messages="err[item.counter.id + '-2']"
                      v-model.number="item.value_2"
                      required/>
        <v-text-field v-if="item.counter.type === 'ELECTRO_3'"
                      type="number"
                      :label="counterLabel(item.counter, 3)"
                      :error-messages="err[item.counter.id + '-3']"
                      v-model.number="item.value_3"
                      required/>
      </div>
      <v-btn class="mr-4 mb-4" @click="saveChanges">Сохранить</v-btn>
      <v-btn class="mr-4 mb-4" @click="cancelChanges">Отменить</v-btn>
      <v-btn class="mr-4 mb-4" @click.stop="sendConfirmation=true">Отправить в УК</v-btn>
      <v-btn class="mr-4 mb-4" @click.stop="deleteConfirmation=true" v-if="this.receipt.id">Удалить</v-btn>
      <v-dialog v-model="deleteConfirmation" persistent width="290" @keydown.esc="cancelDeletion">
        <v-card>
          <v-toolbar dark dense flat>
            <v-icon>mdi-alert-outline</v-icon>
            <v-toolbar-title class="white--text">Удаление</v-toolbar-title>
          </v-toolbar>
          <v-card-text class="pa-4">Вы действительно желаете удалить показания счётчиков?
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn @click="confirmDeletion">Удалить</v-btn>
            <v-btn @click="cancelDeletion">Отменить</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="sendConfirmation" persistent width="290" @keydown.esc="cancelSend">
        <v-card>
          <v-toolbar dark dense flat>
            <v-icon>mdi-alert-outline</v-icon>
            <v-toolbar-title class="white--text">Отправка</v-toolbar-title>
          </v-toolbar>
          <v-card-text class="pa-4">Вы действительно желаете отправить показания в управляющую компанию?
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn @click="confirmSend">Да</v-btn>
            <v-btn @click="cancelSend">Нет</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-form>
    <v-divider class="my-4"/>
    <div>
      Показания счётчиков воды необходимо вводить в литрах. Это значит, что если вы видете на счетчике
      <span class="cnt">00115.<span class="red--text">342</span></span>,
      то следует вводить все значащие цифры - <span class="cnt">115342</span>
      <v-img contain :src="require('@/assets/counter-to-value.png')" height="114"/>
    </div>
  </v-container>
</template>

<script>
export default {
  name: 'ReceiptEdit',
  props: {
    receiptId: String
  },
  data() {
    return {
      errorMessage: null,
      err: {},
      deleteConfirmation: false,
      sendConfirmation: false,
      counterTypes: {
        "WATER_HOT": "Горячая вода",
        "WATER_COLD": "Холодная вода",
        "ELECTRO_1": "Электричество (1 тариф)",
        "ELECTRO_2": "Электричество (2 тарифа)",
        "ELECTRO_3": "Электричество (3 тарифа)",
      },
      receipt: {
        id: this.receiptId,
        isSent: false,
        values: [],
      },
      lastReceipt: {
        id: null,
        isSent: false,
        values: [],
      },
      validators: [],
    }
  },
  mounted() {
    console.log(`ReceiptEdit ${this.receipt.id}`)
    let promise
    if (this.receipt.id) {
      promise = this.$http.get(`/receipt/${this.receipt.id}`).then(resp => {
        this.receipt = resp.data
        return this.receipt
      })
    } else {
      promise = this.$http.get(`/counter?active=true`)
          .then(resp => {
            this.receipt.timestamp = Date.now()
            resp.data.forEach((c) => this.receipt.values.push({
              counter: c,
              counterId: c.id,
              value_1: null,
              value_2: null,
              value_3: null,
            }))
            return this.receipt
          })
    }
    promise
        .then(() => {
          this.receipt.values.forEach((v) => {
            this.$set(this.err, v.counter.id + '-1', null)
            this.$set(this.err, v.counter.id + '-2', null)
            this.$set(this.err, v.counter.id + '-3', null)
          })
        })
        .then(() => {
          return this.$http.get(`/receipt/before/${this.receipt.timestamp}`)
        })
        .then(resp => {
          this.lastReceipt = resp.data
          const that = this
          for (const v of this.receipt.values) {
            const last = this.lastReceipt.values.find(lv => lv.counterId === v.counterId)
            if (last) {
              const type = v.counter.type
              if (type) {
                const f = function () {
                  const e = (v.value_1 < last.value_1) ? `не может быть меньше чем ${last.value_1}` : null
                  that.$set(that.err, v.counter.id + '-1', e)
                  return e == null
                }
                this.validators.push(f)
                this.$watch(function () {
                  return v.value_1
                }, f)
              }
              if (type === "ELECTRO_2" || type === "ELECTRO_3") {
                const f = function () {
                  const e = (v.value_2 < last.value_2) ? `не может быть меньше чем ${last.value_2}` : null
                  that.$set(that.err, v.counter.id + '-2', e)
                  return e == null
                }
                this.validators.push(f)
                this.$watch(function () {
                  return v.value_2
                }, f)
              }
              if (type === "ELECTRO_3") {
                const f = function () {
                  const e = (v.value_3 < last.value_3) ? `не может быть меньше чем ${last.value_3}` : null
                  that.$set(that.err, v.counter.id + '-3', e)
                  return e == null
                }
                this.validators.push(f)
                this.$watch(function () {
                  return v.value_3
                }, f)
              }
            }
          }

        })
  },
  computed: {},
  methods: {
    counterLabel: function (counter, n) {
      const postfix = counter.type.startsWith("ELECTRO") ? {
        1: " - день",
        2: " - ночь",
        3: " - пиковая"
      }[n] ?? "" : ""
      return this.counterTypes[counter.type] + postfix + " - " + counter.title + " - №" + counter.number
    },
    saveChanges: function () {
      const ok = this.validators.reduce((acc, cur) => {
        return cur() && acc
      }, true)
      if (ok) {
        this.$http.post("/receipt", this.receipt)
            .then(() => this.$router.push({name: 'Receipts'}))
            .catch(err => {
              console.error("error!!!", err.response.data)
              this.errorMessage = err.response.data.message
            })
      }
    },
    cancelChanges: function () {
      this.$router.push({name: 'Receipts'})
    },
    cancelDeletion: function () {
      this.deleteConfirmation = false
    },
    confirmDeletion: function () {
      this.deleteConfirmation = false
      this.$http.delete(`/receipt/${this.receipt.id}`).then(() => this.$router.push({name: 'Receipts'}))
    },
    cancelSend: function () {
      this.sendConfirmation = false
    },
    confirmSend: function () {
      this.sendConfirmation = false
      const ok = this.validators.reduce((acc, cur) => {
        return cur() && acc
      }, true)
      if (ok) {
        this.$http
            .post("/receipt", this.receipt)
            .then(resp => {
              this.receipt.id = resp.data
              return this.receipt.id
            })
            .then(id => this.$http.get(`/receipt/${id}/send`))
            .then(() => this.$http.get(`/receipt/${this.receipt.id}`))
            .then(resp => {
              this.receipt = resp.data
              return this.receipt
            })
            .catch(err => {
              console.error("error!!!", err.response.data)
              this.errorMessage = err.response.data.message
            })
      }
    }
  }

}
</script>

<style lang="css" scoped>
span.cnt {
  background-color: lightgray;
  font-family: monospace;
}
</style>